import { useEffect, useState } from "react";
import { PostApiRoutes } from "../../../../../shared/api-routes/post/post.api-routes";
import http from "../../../../../shared/utils/http";
import { CommentInfo } from "../comment/Comment";
import CommentReply from "../comment/CommentReply";
import "./CommentReplyList.scss";

export interface CommentReplyListProps {
	parentComment_id: string;
	postId: string;
	onDeleteComment: (reply_id: string) => void;
	onClickReply: any;
	newRepliesId: string[];
}

const CommentReplyList: React.FC<CommentReplyListProps> = ({
	parentComment_id,
	postId,
	onDeleteComment,
	onClickReply,
	newRepliesId,
}) => {
	const [replies, setReplies] = useState<CommentInfo[]>([]);

	useEffect(() => {
		http
			.get(PostApiRoutes.GET_COMMENT_REPLIES(postId, parentComment_id))
			.then((res) => {
				setReplies(
					res.filter((reply: CommentInfo) => !newRepliesId.includes(reply.id))
				);
			});
	}, [parentComment_id]);

	const onDeleteReply = (reply_id: string) => {
		setReplies((prev) => prev.filter((reply) => reply.id !== reply_id));
		onDeleteComment(reply_id);
	};

	return (
		<div className="replies-list">
			{replies.map((reply) => {
				return (
					<CommentReply
						key={reply.id}
						onClickReply={onClickReply}
						comment={reply}
						onDeleteReply={onDeleteReply}
						postId={postId}
					/>
				);
			})}
		</div>
	);
};

export default CommentReplyList;
